import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactDOMServer from 'react-dom/server';


console.log('index.tsx...');


//ReactDOM.hydrateRoot(
//  document.querySelector('#root')!,
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//);


//ReactDOM.hydrateRoot(
//  document.querySelector('#root')!,
//    <App />
//);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


/*
ReactDOMServer.renderToPipeableStream(<App />,
 {
  onShellReady() {
    // The content above all Suspense boundaries is ready.
    // If something errored before we started streaming, we set the error code appropriately.
    console.log('onShellReady()');
  },
  onShellError(error) {
    // Something errored before we could complete the shell so we emit an alternative shell.
    console.log('onShonShellError()');
  },
  onAllReady() {
    // If you don't want streaming, use this instead of onShellReady.
    // This will fire after the entire page content is ready.
    // You can use this for crawlers or static generation.
    console.log('onAllReady()');

    // res.statusCode = didError ? 500 : 200;
    // res.setHeader('Content-type', 'text/html');
    // stream.pipe(res);
  },
  onError(err) {
    console.error(err);
  },
});
*/

//const root = ReactDOM.createRoot(
//  document.getElementById('root') as HTMLElement
//);
//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//);

/*
const appHtml = ReactDOMServer.renderToStaticMarkup (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
